/*
 * Cart availability (ADR 113)
 *
 * Verifica cada línea del carrito contra el inventario real de la bóveda
 * (CardVault /api/cart/check-availability). Si algo ya no está disponible:
 *   - marca la línea con un chip "Agotado" / "Quedan N" (design system CardVault),
 *   - bloquea el checkout,
 *   - ofrece UN solo botón "Quitar agotados y continuar" que limpia el carrito
 *     (quita agotados, recorta parciales) en un toque y recarga.
 * Si la verificación falla por red u otro error, NO bloquea (fail-open).
 *
 * Fuente de items: /cart.js (autoritativa de Shopify). El endpoint de CardVault
 * también encola la discrepancia para que el cron sincronice Shopify.
 */
(function () {
  var isLocal = window.location.port === '9292' || window.location.hostname === '127.0.0.1';
  var CARDVAULT_ORIGIN = isLocal ? 'http://cards.the-vault.mx:3000' : 'https://cards.the-vault.mx';
  var API_URL = CARDVAULT_ORIGIN + '/api/cart/check-availability';

  var WARNING_CLASS = 'vault-availability-warning';
  var SOLD_OUT_LABEL = 'Agotado';
  var PARTIAL_LABEL = 'Quedan {n}';
  var BLOCK_MSG = 'Algunos artículos ya no están disponibles.';
  var RESOLVE_MSG = 'Quitar agotados y pagar';
  var RESOLVING_MSG = 'Actualizando carrito…';

  // Chip del design system de CardVault (Badge variant="destructive").
  var CHIP_CSS = 'display:inline-flex;align-items:center;border-radius:8px;padding:2px 10px;' +
    'font-size:12px;font-weight:600;line-height:1.6;color:#ef4444;background:rgba(239,68,68,0.2);';

  var observer = null;
  var debounceTimer = null;
  var unavailable = []; // [{ variant_id, available_quantity }]
  var variantToProduct = {}; // variant_id -> product_id (de /cart.js, para buscar otras versiones)

  function getCheckoutButtons() {
    return document.querySelectorAll('.cart__checkout-button');
  }

  // Solo re-habilitamos lo que NOSOTROS deshabilitamos; no pisamos el disabled
  // que Shopify pone con carrito vacío.
  function setCheckoutBlocked(blocked) {
    getCheckoutButtons().forEach(function (btn) {
      if (blocked) {
        btn.setAttribute('disabled', 'disabled');
        btn.setAttribute('aria-disabled', 'true');
        btn.dataset.vaultBlocked = '1';
      } else if (btn.dataset.vaultBlocked) {
        btn.removeAttribute('disabled');
        btn.removeAttribute('aria-disabled');
        delete btn.dataset.vaultBlocked;
      }
    });
  }

  function clearWarnings() {
    document.querySelectorAll('.' + WARNING_CLASS).forEach(function (el) { el.remove(); });
    document.querySelectorAll('.cart-item[data-vault-unavailable]').forEach(function (row) {
      row.removeAttribute('data-vault-unavailable');
    });
  }

  function findCartRow(variantId) {
    var input = document.querySelector('[data-quantity-variant-id="' + variantId + '"]');
    return input ? input.closest('.cart-item') : null;
  }

  function makeChip(label) {
    var chip = document.createElement('span');
    chip.className = WARNING_CLASS;
    chip.setAttribute('role', 'status');
    chip.textContent = label;
    chip.style.cssText = CHIP_CSS;
    return chip;
  }

  function renderLineChip(row, label) {
    row.setAttribute('data-vault-unavailable', '1');
    var nameCell = row.querySelector('.cart-item__name');
    var holder = document.createElement('div');
    holder.className = WARNING_CLASS;
    holder.style.cssText = 'margin-top:0.4rem;';
    holder.appendChild(makeChip(label));
    if (nameCell && nameCell.parentNode) {
      nameCell.parentNode.insertBefore(holder, nameCell.nextSibling);
    } else {
      row.appendChild(holder);
    }
    return holder;
  }

  // Bajo una línea agotada, ofrece otras impresiones del mismo nombre que SÍ hay
  // en la bóveda (vía el módulo compartido). Best-effort: si no hay o falla, nada.
  function renderLineAlternatives(holder, productId) {
    if (!productId || !window.VaultCardVersions) return;
    var box = document.createElement('div');
    box.className = WARNING_CLASS;
    box.style.cssText = 'margin-top:0.5rem;';
    holder.appendChild(box);
    window.VaultCardVersions.fetchVersions(productId).then(function (versions) {
      if (!versions || !versions.length) return;
      var title = document.createElement('p');
      title.textContent = 'Otras versiones disponibles:';
      title.style.cssText = 'margin:0 0 0.4rem;font-size:12px;color:#6b7280;font-weight:600;';
      box.appendChild(title);
      var list = document.createElement('div');
      box.appendChild(list);
      window.VaultCardVersions.renderChips(list, versions);
    });
  }

  function renderResolveBanner() {
    getCheckoutButtons().forEach(function (btn) {
      var container = btn.closest('.cart__ctas') || btn.parentNode;
      if (!container || !container.parentNode) return;

      var wrap = document.createElement('div');
      wrap.className = WARNING_CLASS;
      wrap.style.cssText = 'margin:0 0 0.8rem;text-align:center;';

      var msg = document.createElement('p');
      msg.setAttribute('role', 'alert');
      msg.textContent = BLOCK_MSG;
      msg.style.cssText = 'color:#b42318;font-size:1.3rem;margin:0 0 0.6rem;font-weight:600;';

      var action = document.createElement('button');
      action.type = 'button';
      action.className = 'button';
      action.style.cssText = 'width:100%;';
      action.textContent = RESOLVE_MSG;
      action.addEventListener('click', function () { resolveUnavailable(action); });

      wrap.appendChild(msg);
      wrap.appendChild(action);
      container.parentNode.insertBefore(wrap, container);
    });
  }

  // Quita agotados (quantity 0) y recorta parciales a lo disponible, en serie,
  // y al terminar lleva directo a pagar (o a /cart si quedó vacío).
  function resolveUnavailable(triggerBtn) {
    if (!unavailable.length) return;
    document.querySelectorAll('.' + WARNING_CLASS + ' button').forEach(function (b) {
      b.disabled = true;
      b.textContent = RESOLVING_MSG;
    });
    var queue = unavailable.slice();
    function finish() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          window.location.href = (cart && cart.item_count > 0) ? '/checkout' : '/cart';
        })
        .catch(function () { window.location.href = '/cart'; });
    }
    function next() {
      if (!queue.length) { finish(); return; }
      var it = queue.shift();
      var qty = it.available_quantity > 0 ? it.available_quantity : 0;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: String(it.variant_id), quantity: qty })
      })
        .then(function () { next(); })
        .catch(function () { next(); });
    }
    next();
  }

  function getCartItems() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart || !cart.items) return [];
        return cart.items.map(function (it) {
          return { variant_id: it.variant_id, quantity: it.quantity, product_id: it.product_id };
        });
      });
  }

  function apply(data) {
    if (!data || !Array.isArray(data.items)) return; // fail-open
    if (observer) observer.disconnect();
    clearWarnings();
    unavailable = [];
    data.items.forEach(function (it) {
      if (it.available) return;
      unavailable.push({ variant_id: it.variant_id, available_quantity: it.available_quantity });
      var row = findCartRow(it.variant_id);
      if (!row) return;
      var label = it.available_quantity > 0
        ? PARTIAL_LABEL.replace('{n}', it.available_quantity)
        : SOLD_OUT_LABEL;
      var holder = renderLineChip(row, label);
      renderLineAlternatives(holder, variantToProduct[String(it.variant_id)]);
    });
    if (unavailable.length) renderResolveBanner();
    setCheckoutBlocked(unavailable.length > 0);
    if (observer) startObserver();
  }

  function runCheck() {
    if (!document.querySelector('.cart-item')) return; // no hay carrito en pantalla
    getCartItems()
      .then(function (items) {
        if (!items.length) return;
        variantToProduct = {};
        items.forEach(function (it) { variantToProduct[String(it.variant_id)] = it.product_id; });
        return fetch(API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(apply);
      })
      .catch(function () { /* fail-open: nunca bloquear por error */ });
  }

  function scheduleCheck() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(runCheck, 350);
  }

  // Ignora las mutaciones que provoca este mismo script (chips, banner, alternativas
  // async): todas viven dentro de un nodo con WARNING_CLASS. Sin esto, inyectar las
  // "otras versiones" tras reconectar el observer dispararía un re-check en bucle.
  function isSelfMutation(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var t = mutations[i].target;
      if (!(t && t.nodeType === 1 && t.closest && t.closest('.' + WARNING_CLASS))) return false;
    }
    return true;
  }

  function startObserver() {
    if (!observer) {
      observer = new MutationObserver(function (mutations) {
        if (isSelfMutation(mutations)) return;
        scheduleCheck();
      });
    }
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { runCheck(); startObserver(); });
  } else {
    runCheck();
    startObserver();
  }
})();
